export default {
      id: "icon-archive-usage",
      viewBox: "0 0 24 24",
      url: "/" + "assets/sprite.svg#icon-archive",
      toString: function () {
        return this.url;
      }
    }